"use client"

import { DraftCollectible, UnsavedCollectible } from "@/types/collectibles"
import { SimulateContractReturnType } from "viem"
import { Blog, Note } from "@types"
import TxnError from "./TxnError"
import MintBtnReady from "./MintBtnReady"
import { CompletedNFTMintBtnProps } from "../types"
import { addOrUpdateCollectible } from "@/lib/api/collectibles"
import { useAccount } from "wagmi"
import {
  useCreateSimulateTxnExistingNFT,
  useCreateSimulateTxnNewNFT,
} from "@/app/@modal/[blogSlug]/(.)nft/hooks/useCreateSimulateTxn"

export function NewNFTMintBtnSimulate({
  post,
  blog,
  draftCollectible,
  className,
}: {
  post: Note
  blog: Blog
  draftCollectible: DraftCollectible
  className?: string
}) {
  const simulateData = useCreateSimulateTxnNewNFT({
    post,
    blog,
  })

  const collectorWallet = useAccount().address

  const callback = async (txHash: string) => {
    console.log("Tx receipt: callback running, txHash:", txHash)

    const collectibleWithTxHash: UnsavedCollectible = {
      ...draftCollectible,
      txHash,
      collectorWallet: collectorWallet as `0x${string}`,
    }

    console.log("Adding collectible to backend", collectibleWithTxHash)

    await addOrUpdateCollectible(collectibleWithTxHash)
  }

  if (simulateData.data || simulateData.isLoading) {
    return (
      <MintBtnReady
        collectible={draftCollectible}
        key={draftCollectible.noteId}
        simulateRequest={
          simulateData.data as unknown as SimulateContractReturnType
        }
        onTxHashCallback={(txHash) => callback(txHash)}
        onTxReceiptCallback={(txReceipt) =>
          callback(txReceipt.data?.transactionHash as string)
        }
        isFirstMint
        className={className}
      />
    )
  }

  return (
    <TxnError
      collectible={draftCollectible}
      simulateData={simulateData}
      className={className}
    />
  )
}

export function ExistingNFTMintBtnSimulate({
  collectible,
  className,
}: CompletedNFTMintBtnProps) {
  const simulateData = useCreateSimulateTxnExistingNFT({
    collectible,
  })

  if (simulateData.data || simulateData.isLoading) {
    return (
      <MintBtnReady
        key={collectible.noteId}
        collectible={collectible}
        simulateRequest={
          simulateData.data as unknown as SimulateContractReturnType
        }
        className={className}
      />
    )
  }

  return (
    <TxnError
      collectible={collectible}
      simulateData={simulateData}
      className={className}
    />
  )
}
